<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header">
                <h1>Survey Report</h1>
            </div>
            <div class="form-group" style="padding-bottom:0px;">
                <div class="form-item">
                    <label for="movementname">Movement Type *</label>
                    <select id="movementname" v-model="movementid" class="custom-select">
                        <option v-for="movement in movement" :key="movement.Movid" :value="movement.Movid">
                            {{ movement.Name }}
                        </option>
                    </select>
                </div>
                <div class="form-item">   
                    <label for="contnumber">Container No</label>
                    <input type="text" id="contnumber" v-model="contnumber" />
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="generate_report" :disabled="isSubmitting">Generate
                        Report</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
export default {
    data() {
        return {
            movement: JSON.parse(localStorage.getItem('movements')) || [],
            contnumber: '',
            movementid: 0,
            isSubmitting: false,
        }
    },
    methods: {
        async generate_report() {
            if (this.isSubmitting) return;
            const contnumber = this.contnumber;
            if (!contnumber) {
                useToast().error('Please enter a container number.');
                return;
            }
            if (this.movementid == 0) {
                useToast().error('Please select a movement type.');
                return;
            }

            this.isSubmitting = true;
            try {
                const response = await axios.get('/CreateONBoardSurveyReportPDF?contno=' + contnumber+'&movementid=' + this.movementid);
                //console.log(response.data)
                if (response.data[0] == 0) {
                    useToast().error(response.data[1]);
                } else if (response.data[0] == 2) {
                    useToast().success(response.data[1]);
                } else {
                    useToast().success('Report Generate Successfully');
                    //console.log(response)
                    this.printreport(response.data[1]);
                }
            } catch (error) {
                //console.log(error)
                useToast().error('An error occurred while generating the report');
            } finally {
                this.isSubmitting = false;
            }
        },
        async printreport(filename) {
            try {
                const token = localStorage.getItem('access_token');
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                };
                const urlpath = `/printreportpdf?filename=${filename}`;
                //console.log(urlpath)
                const response = await axios.get(urlpath, config);
                const pdfBlob = new Blob([response.data], { type: "application/pdf" });
                const url = URL.createObjectURL(pdfBlob);
                window.open(url);

            } catch (error) {
                console.error('Error generating report:', error);
                useToast().error('An error occurred while opening the report');
            }
        },
    },
}
</script>
<style scoped>
.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 25%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>